export default function generateUUID() {
  const chars = '0123456789abcdef';
  let uuid = '';

  for (let i = 0; i < 36; i += 1) {
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      uuid += '-';
    } else if (i === 14) {
      uuid += '4'; // Version 4 UUID (randomly generated)
    } else if (i === 19) {
      // eslint-disable-next-line no-bitwise
      uuid += chars[(Math.random() * 4) | 8];
    } else {
      uuid += chars[Math.floor(Math.random() * 16)];
    }
  }

  return uuid;
}
